import { buildingTypeSchema } from "./buildingTypeSchema";
import { businessTypeSchema } from "./businessTypeSchema";
import { productFamilySchema } from "./productFamilySchema";
import { z } from "zod";

export const leadForwardingProjectBaseSchema = z.object({
  projectName: z.coerce.string().max(300),
  customerCompanyName: z.coerce.string().max(100),
  customerCompanyBusinessId: z.coerce.string().max(20).optional(),
  customerCompanyStreetAddress: z.coerce.string().max(100),
  customerCompanyPostalCode: z.coerce.string().max(100),
  customerCompanyCity: z.coerce.string().max(100),
  customerCompanyCountry: z.coerce.string().min(2).max(2).describe("ISO 3166-1 alpha-2 code"),
  customerContactFirstName: z.coerce.string().max(100),
  customerContactLastName: z.coerce.string().max(100),
  customerContactEmail: z.coerce.string().max(100),
  customerContactPhone: z.coerce.string().max(100),
  estimatedRevenue: z.coerce.number(),
  estimatedDeliveryDate: z.string().date(),
  lastOrderingDate: z.string().date().optional(),
  buildingType: z.lazy(() => buildingTypeSchema),
  businessType: z.lazy(() => businessTypeSchema),
  productFamily: z.lazy(() => productFamilySchema),
  mainSegment: z.coerce
    .string()
    .describe("One of the segment names defined in MAIN_SEGMENT_MAPPING environment variable."),
  subSegment: z.coerce
    .string()
    .describe(
      "One of the segment names defined in SUB_SEGMENT_MAPPING environment variable. Also, should be a child segment of the mainSegment in CRM.",
    ),
  bonusPercentage: z.coerce.number(),
  currency: z.coerce.string().describe("Currency code of partner's currency (from BC)"),
});

export type LeadForwardingProjectBase = z.infer<typeof leadForwardingProjectBaseSchema>;
